import React, { useContext, useState } from 'react';
import ApiURL from '../Api/Api';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import TransactionProofImage from './TransactionProofImage';
import { SidebarContext } from './SidebarContext';

const TransactionSearch = () => {
  const [transactionNo, setTransactionNo] = useState('');
  const [transactionData, setTransactionData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { isSidebarOpen } = useContext(SidebarContext);

  const fetchTransactions = async () => {
    setIsLoading(true);
    try {
      const userId = localStorage.getItem('id');
      const role = localStorage.getItem('role');
      const response = await fetch(`${ApiURL}/txnSearch.php?txnNo=${encodeURIComponent(transactionNo)}&user_id=${encodeURIComponent(userId || '')}&role=${encodeURIComponent(role || '')}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data);

      if (data.error) {
        throw new Error(data.message || 'Transaction not found');
      }

      if (data.data && data.data.length > 0) {
        setTransactionData(data.data[0]);
      } else {
        setTransactionData(null);
      }
    } catch (err) {
      console.error('Fetch error:', err);
      setError(err.message);
      setTransactionData(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-shell min-h-screen pt-16">
      <Navbar />
      <Sidebar />
      <main className={`min-w-0 px-4 py-5 sm:px-6 transition-all duration-300 ${isSidebarOpen ? 'lg:ml-72' : ''}`}>
        <section className="page-surface mb-5 p-4 sm:p-5">
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand-600">Daily Txn Book</p>
          <h1 className="mt-1 text-2xl font-black text-slate-900">Transaction Search</h1>
          <p className="mt-1 text-sm text-slate-500">Search by transaction number and review the full transaction record.</p>
        </section>

        <section className="pro-card p-4 sm:p-5">
          <form onSubmit={(e) => { e.preventDefault(); fetchTransactions(); }}>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
              <div className="min-w-0 flex-1">
                <label className="block text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-1.5">
                  Transaction No
                </label>
                <input
                  type="text"
                  id="transaction_no"
                  value={transactionNo}
                  onChange={(e) => setTransactionNo(e.target.value)}
                  className="h-11 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 outline-none transition focus:border-brand-500 focus:ring-2 focus:ring-brand-100"
                  placeholder="Enter transaction number"
                />
              </div>
              <button
                type="submit"
                disabled={isLoading || !transactionNo.trim()}
                className="pro-button pro-button-primary h-11 px-5 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {isLoading ? 'Searching...' : 'Search'}
              </button>
            </div>

            {error && (
              <div className="mt-4 rounded-lg border border-rose-200 bg-rose-50 px-4 py-3 text-sm font-semibold text-rose-700">{error}</div>
            )}

            {transactionData && (
              <div className="mt-5 border-t border-slate-100 pt-5">
                <h2 className="mb-3 text-sm font-black uppercase tracking-widest text-slate-500">Transaction Information</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                      <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Amount Type:
                        </label>
                        <input
                          type="text"
                          value={transactionData.amount_type || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Credit Amount:
                        </label>
                        <input
                          type="number"
                          value={transactionData.credit_amt || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Debit Amount:
                        </label>
                        <input
                          type="number"
                          value={transactionData.debit_amt || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Particulars / GIVEN To:
                        </label>
                        <input
                          type="text"
                          value={transactionData.particuler_to || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Site:
                        </label>
                        <input
                          type="text"
                          value={transactionData.site || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Project:
                        </label>
                        <input
                          type="text"
                          value={transactionData.project_name || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Main Head:
                        </label>
                        <input
                          type="text"
                          value={transactionData.main_head || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Sub Head:
                        </label>
                        <input
                          type="text"
                          value={transactionData.sub_head || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Remarks:
                        </label>
                        <input
                          type="text"
                          value={transactionData.remarks || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div>
                      <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Proof Image:
                        </label>
                        <TransactionProofImage path={transactionData.attachment_path} />
                      </div>
                      {/* <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Created By:
                        </label>
                        <input
                          type="text"
                          value={transactionData.currentUser || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div> */}
                      {/* <div>
                        <label className="block uppercase text-gray-600 text-xs font-bold mb-2">
                          Created Date:
                        </label>
                        <input
                          type="datetime-local"
                          value={transactionData.currentTime || ''}
                          className="border border-gray-300 px-3 py-2 rounded-md shadow-sm text-gray-600 text-sm w-full bg-gray-50 focus:outline-none"
                          disabled
                        />
                      </div> */}
                </div>
              </div>
            )}
          </form>
        </section>
      </main>
    </div>
  );
};

export default TransactionSearch;
